module.exports = __webpack_public_path__ + "b8bf5a4e6282510d829111dc2f1177a1.svg";